export { BookingsView } from "../../components/bookings/bookings-view";
